import React, {type JSX} from 'react';
import {Button} from '@mui/material';
import {styled} from '@mui/material/styles';
import {ChevronLeftIcon} from '../../../../assets/icons/chevronLeftIcon';
import {ChevronRightIcon} from '../../../../assets/icons/chevronRightIcon';

const StyledMonthSwitchButton = styled(Button)(({theme}) => ({
  '&.MuiButton-root': {
    height: '36px',
    width: '36px',
    minWidth: 'unset',
    border: `1px solid ${theme.palette.grey[400]}`,
    color: theme.palette.primary.main,
    '&:hover': {
      border: `1px solid ${theme.palette.primary.main}`,
    },
  },
}));

type Props = {
  onClick: VoidFunction;
  disabled?: boolean;
};

export function PreviousButton({
  onClick,
  disabled,
}: Readonly<Props>): JSX.Element {
  return (
    <StyledMonthSwitchButton
      onClick={onClick}
      data-testid="prev-btn"
      disabled={disabled}
      variant="outlined"
    >
      <ChevronLeftIcon />
    </StyledMonthSwitchButton>
  );
}

export function NextButton({onClick, disabled}: Readonly<Props>): JSX.Element {
  return (
    <StyledMonthSwitchButton
      onClick={onClick}
      data-testid="next-btn"
      disabled={disabled}
      variant="outlined"
    >
      <ChevronRightIcon />
    </StyledMonthSwitchButton>
  );
}
